import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const TrashIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14 0C15.1046 0 16 0.89543 16 2V3H19.5C20.3284 3 21 3.67157 21 4.5V5.5C21 6.15311 20.5826 6.70873 20 6.91465V22C20 23.1046 19.1046 24 18 24H6C4.89543 24 4 23.1046 4 22V6.91465C3.4174 6.70873 3 6.15311 3 5.5V4.5C3 3.67157 3.67157 3 4.5 3H8V2C8 0.89543 8.89543 0 10 0H14ZM15 2V3H9V2L9.00673 1.88338C9.06449 1.38604 9.48716 1 10 1H14L14.1166 1.00673C14.614 1.06449 15 1.48716 15 2ZM5 7H19V22L18.9933 22.1166C18.9355 22.614 18.5128 23 18 23H6L5.88338 22.9933C5.38604 22.9355 5 22.5128 5 22V7ZM20 5.5C20 5.77614 19.7761 6 19.5 6H4.5C4.22386 6 4 5.77614 4 5.5V4.5C4 4.22386 4.22386 4 4.5 4H8H16H19.5C19.7761 4 20 4.22386 20 4.5V5.5ZM12.4919 10.0212C12.4496 9.78799 12.2455 9.61111 12 9.61111C11.7239 9.61111 11.5 9.83497 11.5 10.1111V19.8889L11.5081 19.9788C11.5504 20.212 11.7545 20.3889 12 20.3889C12.2761 20.3889 12.5 20.165 12.5 19.8889V10.1111L12.4919 10.0212ZM15 9.61111C15.2455 9.61111 15.4496 9.78799 15.4919 10.0212L15.5 10.1111V19.8889C15.5 20.165 15.2761 20.3889 15 20.3889C14.7545 20.3889 14.5504 20.212 14.5081 19.9788L14.5 19.8889V10.1111C14.5 9.83497 14.7239 9.61111 15 9.61111ZM9.49194 10.0212C9.44961 9.78799 9.24546 9.61111 9 9.61111C8.72386 9.61111 8.5 9.83497 8.5 10.1111V19.8889L8.50806 19.9788C8.55039 20.212 8.75454 20.3889 9 20.3889C9.27614 20.3889 9.5 20.165 9.5 19.8889V10.1111L9.49194 10.0212Z'
      />
    </svg>
  );
};
